import { CardHeader as MuiCardHeader } from "@material-ui/core";
import { styled } from "@material-ui/styles";

const CardHeader = styled(MuiCardHeader)({
  textAlign: "center",
  color: "#FF995B",
});

export default CardHeader;
